// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vM8a","colBig":"styles_colBig__1F5be","colSmall":"styles_colSmall__1LT7c"};